import { Hatch } from "react-migration/domains/constraints/components/Hatch/Hatch";

interface SiteHatchProps {
  stageColor?: string;
}

export function SiteHatch({ stageColor }: SiteHatchProps) {
  return <Hatch borderColor={stageColor} fillColor="transparent" />;
}
